import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-view.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSViewRow extends React.PureComponent {
  static displayName = 'EGDSViewRow';
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    adSlot: false,
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    canvasTheme: 'primary',
    // eslint-disable-next-line react/default-props-match-prop-types -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    layout: 'fullwidth'
  };
  render() {
    const {
      adSlot,
      children,
      className,
      canvasTheme,
      layout
    } = this.props;
    const cssClassNames = getClassNameList('uitk-view-row', `uitk-view-row-theme-${canvasTheme}`, `uitk-view-row-layout-${layout}`, `uitk-view-row-adslot-${adSlot}`, className);
    return jsx("div", {
      className: cssClassNames,
      children: children
    });
  }
}
export { EGDSViewRow };